import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetRolePermissionSelectedList = () => {
  const [loading, setLoading] = useState(false);
  const [selectedPermissionList, setSelectedPermissionList] = useState([]);
  const [pageRef, setPageRef] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const getSelectedPermissionList = ({ Guid, Page, Term = '', Count }) => {
    setLoading(true);

    axiosClient
      .get('SettingAccount/Role/Permission/SelectedList', {
        params: { Guid, Page, Count, Term },
      })
      .then(res => {
        if (res.status === 200) {
          setPageRef(res.data.value);
          setSelectedPermissionList(
            res.data.value.list.map(permission => ({
              id: permission.permissionGuid,
              display: permission.display,
              selected: permission.selected,
            })),
          );
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return {
    getSelectedPermissionList,
    loading,
    selectedPermissionList,
    pageRef,
  };
};

export { useGetRolePermissionSelectedList };
